import React from 'react';
import styles from './ExpedienteLockModal.module.css';
import { MyIcons } from '../../icons/my-icons';
import Button from '../../ui/button';

const ExpedienteLockModal = ({ 
  isOpen, 
  lockInfo,
  takeoverRequest,
  pendingTakeoverRequest,
  onRequestTakeover,
  onRespondTakeover,
  onDismiss,
  isConnected,
  connectionError
}) => {

  if (!isOpen) return null;

  // Modal para cuando alguien más está editando
  const renderLockedByOtherModal = () => (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <MyIcons
            name="alarm"
            width={24}
            height={24}
            color="var(--orange)"
          />
          <h3 className={styles.modalTitle}>Expediente en edición</h3>
        </div>

        <div className={styles.modalContent}>
          <p className={styles.infoText} style={{color: '#000000'}}>
            Este expediente está siendo editado por:
          </p>
          <div className={styles.userInfo}>
            <MyIcons
              name="user"
              width={20}
              height={20}
              color="var(--primary)"
            />
            <span className={styles.userName} style={{color: '#000000', fontWeight: 'bold'}}>
              {lockInfo.userName || `Usuario ${lockInfo.lockedBy}`}
            </span>
          </div>
          
          {lockInfo.lockTimestamp && (
            <p className={styles.timestampText} style={{color: '#666666'}}>
              Desde: {new Date(lockInfo.lockTimestamp).toLocaleString('es-ES')}
            </p>
          )}

          <div className={styles.warningBox}>
            <MyIcons
              name="alarm"
              width={16}
              height={16}
              color="var(--orange)"
            />
            <span style={{color: '#856404'}}>
              No puedes editar el expediente mientras esté siendo utilizado por otro usuario.
            </span>
          </div>

          {pendingTakeoverRequest ? (
            <div className={styles.pendingRequest}>
              <MyIcons
                name="chat"
                width={16}
                height={16}
                color="var(--blue)"
              />
              <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                <span style={{fontWeight: 'bold', color: '#0c5460'}}>
                  Solicitud enviada a {lockInfo.userName || `Usuario ${lockInfo.lockedBy}`}
                </span>
                <span style={{color: '#0c5460'}}>Esperando respuesta...</span>
              </div>
            </div>
          ) : (
            <div className={styles.actionSection}>
              <p className={styles.actionText} style={{color: '#000000'}}>
                ¿Necesitas editar urgentemente este expediente?
              </p>
              <p className={styles.actionSubtext} style={{color: '#666666'}}>
                Se enviará una solicitud a <strong style={{color: '#000000'}}>{lockInfo.userName || `Usuario ${lockInfo.lockedBy}`}</strong> para que te ceda el control de edición.
              </p>
              <Button
                variant="secondary"
                onClick={onRequestTakeover}
              >
                Solicitar permiso a {lockInfo.userName || `Usuario ${lockInfo.lockedBy}`}
              </Button>
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          <Button variant="primary" onClick={onDismiss}>
            Entendido
          </Button>
        </div>
      </div>
    </div>
  );

  // Modal para cuando alguien solicita permiso para editar
  const renderTakeoverRequestModal = () => (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <MyIcons
            name="chat"
            width={24}
            height={24}
            color="var(--blue)"
          />
          <h3 className={styles.modalTitle}>Solicitud de edición</h3>
        </div>

        <div className={styles.modalContent}>
          <p className={styles.infoText} style={{color: '#000000'}}>
            El siguiente usuario solicita editar este expediente:
          </p>
          <div className={styles.userInfo}>
            <MyIcons
              name="user"
              width={20}
              height={20}
              color="var(--primary)"
            />
            <span className={styles.userName} style={{color: '#000000', fontWeight: 'bold'}}>
              {takeoverRequest.requestingUserName || `Usuario ${takeoverRequest.requestingUserId}`}
            </span>
          </div>

          <div className={styles.infoBox}>
            <MyIcons
              name="alarm"
              width={16}
              height={16}
              color="var(--blue)"
            />
            <span style={{color: '#0c5460'}}>
              Si aceptas, perderás el control de edición del expediente. 
              Asegúrate de haber guardado todos los cambios.
            </span>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <Button 
            variant="secondary" 
            onClick={() => onRespondTakeover(false)}
            
          >
            Denegar
          </Button>
          <Button 
            variant="primary" 
            onClick={() => onRespondTakeover(true)}
            
          >
            Permitir edición
          </Button>
        </div>
      </div>
    </div>
  );

  // Modal de error de conexión
  const renderConnectionErrorModal = () => (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <MyIcons
            name="close"
            width={24}
            height={24}
            color="var(--red)"
          />
          <h3 className={styles.modalTitle}>Error de conexión</h3>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.errorBox}>
            <MyIcons
              name="close"
              width={16}
              height={16}
              color="var(--red)"
            />
            <span style={{color: '#721c24'}}>
              No se puede conectar al sistema de bloqueo de expedientes.
            </span>
          </div>
          
          {connectionError && (
            <p className={styles.errorDetails} style={{color: '#721c24', marginTop: '12px'}}>
              Error: {connectionError}
            </p>
          )}

          <p className={styles.infoText} style={{color: '#000000', marginTop: '12px'}}>
            Es posible que múltiples usuarios puedan editar el expediente simultáneamente. 
            Procede con precaución.
          </p>
        </div>

        <div className={styles.modalFooter}>
          <Button variant="primary" onClick={onDismiss}>
            Continuar
          </Button>
        </div>
      </div>
    </div>
  );

  // Decidir qué modal mostrar
  if (connectionError) {
    return renderConnectionErrorModal();
  }

  if (takeoverRequest) {
    return renderTakeoverRequestModal();
  }

  if (lockInfo.isLocked && !lockInfo.lockedByMe) {
    return renderLockedByOtherModal();
  }

  return null;
};

export default ExpedienteLockModal;